import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminUserGroupEmployeeIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class AdminUserGroupEmployeeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AdminUserGroup-002";

        let qbe = btoa(JSON.stringify({
            "ShifamedMessage": {
                "-idoc": "v1.AdminUserGroup-002",
                "-id": uuidv4(),
                "AdminUserGroup": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "AdminEmployee": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }))
        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_user_groups",
            json: true,
            params: {
                "QBE": qbe
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminUserGroupEmployeeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminUserGroup = {};

        adminUserGroup["USID"] = this.getEnterpriseObject().getEnterpriseComponent("AdminUserGroup").getAttributeValue("USID");
        adminUserGroup["Employee"] = {
            "USID": this.getAttributeValue("USID")
        }

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminUserGroup-002";
        payload.ShifamedMessage.AdminUserGroup = adminUserGroup;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_user_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminUserGroup-002",
                "idoc-response": "v1.AdminUserGroup-002"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminUserGroupEmployeeIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };
}

export default AdminUserGroupEmployeeEnterpriseComponent;